import React, { Component } from "react";
import { message } from "antd";
import F from "../../../Functions";

const Print = () => {
  let tWindow = window.open("");
  if (tWindow) {
    const PrintCSS = `
            body {
                font-family: 'Roboto', sans-serif;
            }
            .bfileInfo {
                text-align: left;
                overflow: auto;
                margin-bottom: 20px;
            }
            a {
                color: #000;
                text-decoration: none;
            }
            button {
                display: none;
            }
            .bfileInfo h2 {
                margin: 0;
            }
            .bfileInfo .ant-avatar {
                float: left;
            }
            .bfileInfo .ant-avatar img {
                width: 90px;
                vertical-align: middle;
                margin-right: 20px;
            }
            #notes {
                display: none;
            }
            .cardBlue {
                width: 50%;
                float: left;
            }
            .cardBlue .ant-card-body {
                padding: 20px;
            }
            .cardBlue .ant-card-head {
                background: #1890ff;
                padding: 14px 20px;
                color: #FFF;
                font-weight: bold;
            }
            .ant-list-item {
                clear: both;
                padding: 10px 0;
                overflow: auto;
                border-bottom: 1px solid #E6E6E6;
            }
            .ant-list-item-meta-title {
                float: left;
                width: 50%;
                margin: 0;
            }
            .ant-list-item-meta-title + .ant-list-item-meta-description {
                float: left;
                width: 50%;
            }
            .ant-list-item img {
                width: 24px;
                height: auto;
                margin-right: 20px;
                vertical-align: middle;
            }
            .ant-list-item .ant-avatar img {
                width: 35px;
            }
            hr {
                display: block;
                clear: both;
                border: none;
                height: 20px;
            }
            .ant-card-head-title {
                display: none;
            }
            .ant-card-bordered {
                border: 1px solid #000;
                padding: 40px;
                margin-bottom: 40px;
                text-align: center;
            }
            .ant-radio-group > label {
                display: none;
            }
            .ant-radio-group .ant-radio-wrapper-checked {
                display: block;
            }
            .ant-radio {
                display: none;
            }
            .ant-col-12 {
                float: left;
                width: 50%;
            }
            .racAmount {
                font-size: 20px;
                margin-top: 5px;
            }
            /*                      Faizan Start                              */
            .spac {
                margin: 0;
                padding: 0;
            }
    
            .user-data {
                width: 600px;
                margin: auto;
                font-family: 'Roboto', sans-serif;
            }
    
            .user-data-one {
                padding: 37px 40px 30px;
                height: 142px;
                background-position: bottom;
            }
    
            .user-data-td {
                color: white;
                border: none;
                width: 48%;
            }
    
            .team-heading {
                font-size: 20px;
                font-weight: bold;
                margin: 0;
                margin-bottom: 2.4px;
            }
    
            .team-para {
                font-size: 14px;
                margin: 0;
                margin-bottom: 4px;
            }
    
            .logo-wrap {
                vertical-align: top;
                text-align: end;
            }
    
            .logo-wrap img {
                width: 110px;
            }
    
            .user-table-three {
                padding: 19px 30px;
                width: 100%;
            }
    
            .user-table-four {
                width: 100%;
                padding: 15.9px 20px 18.5px;
                background-color: #fbfbfb;
            }
    
            .cal-wrap {
                text-transform: uppercase;
                margin: 0;
                color: #00152a;
                font-weight: bold;
                font-size: 14px;
                text-align: center;
            }
    
            .cal-wrap-one {
                font-size: 12px;
                text-align: center;
                margin: 0;
                margin-bottom: 18px;
                padding-top: 15px;
            }
    
            .cal-wrap-two {
                font-size: 30px;
                font-weight: bold;
                text-align: center;
                margin: 0;
            }
    
            .user-table-five {
                width: 100%;
                margin-top: 30px;
            }
    
            .user-table-five td {
                color: #00152a;
                text-transform: uppercase;
                font-size: 14px;
                font-weight: bold;
                border-bottom: 1px solid #00152a;
                padding-bottom: 5px;
            }
    
            .user-table-six {
                width: 100%;
                margin-top: 30px;
            }
    
            .car-wrap {
                text-align: center;
                border-right: 0.3px solid #979797;
                width: 50%;
            }
    
            .car-img {
                width: 40px;
            }
    
            .auto-para {
                font-size: 12px;
                font-weight: bold;
                margin: 0;
            }
    
            .num-para {
                font-size: 12px;
                margin: 0;
                margin-top: 5px;
            }
    
            .user-table-seven {
                width: 100%;
                margin-top: 30px;
            }
    
            .user-table-seven td {
                color: #00152a;
                text-transform: uppercase;
                font-size: 14px;
                font-weight: bold;
                border-bottom: 1px solid #00152a;
                padding-bottom: 5px;
            }
    
            .user-table-eight {
                width: 100%;
                margin-top: 30px;
            }
    
            .user-table-eight td {
                text-align: center;
            }
    
            .um-img {
                width: 26px;
            }
    
            .user-table-nine {
                width: 100%;
                margin-top: 30px;
            }
    
            .user-table-nine td {
                text-align: center;
                border-right: 0.3px solid #979797;
                width: 25%;
            }
    
            .user-table-nine td:last-child {
                border: 0px;
            }
    
            .user-td-house {
                text-align: center;
                width: 50%;
            }
    
            .home-wrap {
                font-size: 10px;
                margin: 0;
                margin-top: 5px;
            }
    
            .house-wrap {
                width: 30px;
            }
    
            .bike-wrap {
                width: 26px;
            }
    
            .table-footer {
                margin-top: 120px;
                width: 100%;
            }
    
            .table-footer td {
                height: 40px;
                background-color: #00152a;
            }

            user-data{
                display: none !important;
            }

            @media print{
                .hide-print{
                    display: none;
                  }
              }
              @media print{
                .hide-print{
                    display: none;
                  }
              }
              @media print {
                .user-data {display: block !important;}
              }
              .hk_bg{
                background-color: #00152a !important;
            }
              /*                      Faizan End                              */
        `;
    tWindow.document.write(
      '<html><head><title>Print it!</title><link href="https://fonts.googleapis.com/css?family=Roboto:300,400,700" rel="stylesheet"><style>' +
        PrintCSS +
        "</style></head><body>" +
        document.getElementById("liabilityCard").innerHTML +
        "</body></html>"
    );
    const elems = tWindow.document.querySelectorAll("[style]");
    for (var i = 0; i < elems.length; i++) {
      elems[i].removeAttribute("style");
    }
    const cards = tWindow.document.querySelectorAll(".cardBlue");
    for (var i = 0; i < cards.length; i++) {
      if (i > 0 && i % 2 === 0) {
        var element = cards[i];
        var newElement = document.createElement("hr");
        var elementParent = element.parentNode;
        elementParent.insertBefore(newElement, element);
      }
    }
    tWindow.document.close();
    tWindow.focus();
    setTimeout(function() {
      tWindow.print();
    }, 1000);
  } else {
    message.error(F.translate(`Please allow the popup in your browser.`));
  }
};

export default Print;



// WEBPACK FOOTER //
// ./src/scenes/WizardInvitee/parts/print-liability.js